import {Node} from 'reactflow';

import {DefaultTaskSchemaNodeAdapter} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/DefaultTaskSchemaNodeAdapter';
import {NodeDetailsSidepanelContentProps} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';
import {
  TaskSchemaNodeData,
  TaskSchemaStaticNodeData,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/TaskSchemaNodeRenderer';
import {TaskSchemaNodeRowRenderer} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/TaskSchemaNodeRowRenderer';
import {isFlowchartTaskSchema} from 'processes/processes-platform/isFlowchartTaskSchema';
import {SimpleBenchlingNodeHandle} from 'ui-library/reactflow/nodes/SimpleBenchlingNode/sub-components/SimpleBenchlingNodeHandle';

import {ProcessTaskSchemaGraphQL} from '../../../../../graphql-fragments/processes/schemas/__generated/ProcessTaskSchemaGraphQL';
import {generateTaskSchemaNodeIdentifier} from './flowchartIdentifierUtils';
import {
  FLOWCHART_TASK_SECONDARY_INFO,
  FLOWCHART_OUTPUT_SECONDARY_INFO,
  ProcessFlowchartNodeType,
} from './processFlowchartConfigEditorConstants';

export interface FlowchartOptions {
  onNodeHeaderClick: (nodeId: string) => void;
  onFieldClick: (nodeId: string, fieldId: string) => void;
}

interface NodePosition {
  x: number;
  y: number;
}

/**
 * Generate data for node, using task schema node adapter to customize
 */
export function createStaticNodeDataFromTaskSchema(
  taskSchema: ProcessTaskSchemaGraphQL,
  isOutputNode: boolean
): TaskSchemaStaticNodeData {
  const isFlowchartTask = isFlowchartTaskSchema(taskSchema);
  const isFlowchartOutputNode = isFlowchartTask && isOutputNode;
  // TODO: Use different adapters based on task schema type
  const adapter = new DefaultTaskSchemaNodeAdapter({isFlowchartOutput: isFlowchartOutputNode});
  return {
    id: generateTaskSchemaNodeIdentifier(taskSchema),
    nodeType: ProcessFlowchartNodeType.TASK_SCHEMA_NODE,
    nodeName: adapter.getNodeName({taskSchema}),
    /** Show secondary information to differentiate Flowchart Task/Output nodes from task schema nodes. */
    nodeSecondaryInfo: isFlowchartTask
      ? isFlowchartOutputNode
        ? FLOWCHART_OUTPUT_SECONDARY_INFO
        : FLOWCHART_TASK_SECONDARY_INFO
      : undefined,
    sections: adapter.createSections({taskSchema}),
    hideSectionSummaries: true,
  };
}

export function createNode(
  staticData: TaskSchemaStaticNodeData,
  position: NodePosition,
  options: FlowchartOptions
): Node<TaskSchemaNodeData> {
  // TODO: Use different adapters based on task schema type
  const adapter = new DefaultTaskSchemaNodeAdapter({});
  return {
    id: staticData.id,
    type: ProcessFlowchartNodeType.TASK_SCHEMA_NODE,
    position: {x: 0, y: 0},
    data: {
      ...staticData,
      onNodeHeaderClick: options.onNodeHeaderClick,
      nodeDetailsSidepanelContent: (props: NodeDetailsSidepanelContentProps) =>
        adapter.nodeDetailsSidepanelContent(props),
      onFieldClick: options.onFieldClick,
      rowRenderer: TaskSchemaNodeRowRenderer,
      nodeHeaderHandleRenderer: SimpleBenchlingNodeHandle,
    },
  };
}
